<template>
  <div>
    <div class="w-100 px-8">
      <div class="mt-10 text-center"><b>กรุณากรอก OTP</b></div>
      <br />
      <div class="text-center">
        ระบบได้ทำการส่งรหัส OTP<br />
        ไปยังเบอร์โทรศัพท์ของท่าน
        <span class="primary--text">{{ showPhoneno }}</span>
      </div>
      <div class="fs-14 text-gray text-center mt-2">
        <span>Ref :</span>
        <span class="mx-1" v-if="ref">{{ ref.refCode }}</span>
        <CountDownTimer
          class="mx-1"
          style="font-size: 14px"
          v-if="showCountdowntimer"
          :startmin="timeleft"
          @ontimeout="showCountdowntimer = false"
        ></CountDownTimer>
        <div class="mt-5">
          <ValidationObserver ref="observer">
            <ValidationProvider
              :rules="{
                required: true,
              }"
              name="OTP"
              v-slot="{ errors }"
            >
              <custom-input
                :maxlength="6"
                v-model="otp"
                :center="true"
                placeholder="OTP"
                numberOnly
                outlined
                :error-messages="errors"
              ></custom-input>
            </ValidationProvider>
          </ValidationObserver>
        </div>
        <div style="color:black">
          <div>
            ไม่ได้รับรหัส OTP
            <span
              @click="sentOtp"
              class="primary--text"
              style="text-decoration: underline;"
              >ส่งใหม่อีกครั้ง</span
            >
          </div>
        </div>
      </div>
      <div class="text-center mt-8 mb-5">
        <v-btn :loading="loading" @click="SubmitProcess" color="primary"
          >ยืนยัน</v-btn
        >
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import CustomInput from "@/components/CustomInput.vue";
import CountDownTimer from "@/components/CountDownTimer.vue";
export default {
  components: {
    CustomInput,
    CountDownTimer,
  },
  data() {
    return {
      timeleft: 5,
      showCountdowntimer: true,
      loading: false,
      otp: "",
    };
  },
  computed: {
    showPhoneno() {
      if (
        this.$store.state.ref &&
        this.$store.state.ref.phoneNumber.length === 10
      ) {
        let phone = this.$store.state.ref.phoneNumber;
        let data = [
          phone[0],
          phone[1],
          phone[2],
          "-xxx-",
          phone[6],
          phone[7],
          phone[8],
          phone[9],
        ];
        return data.join("");
      } else {
        return this.$store.state.ref.phoneNumber
          ? this.$store.state.ref.phoneNumber
          : "";
      }
    },
    ref() {
      return this.$store.state.ref;
    },
    pageId() {
      return this.query.pageid;
    },
  },
  methods: {
    async sentOtp() {
      this.loading = true;
      this.showCountdowntimer = false;
      // Call api to generate otp

      let body = {
        pageId: this.pageId,
        userId: this.userid,
        phone: this.ref.phoneNumber,
      };
      let otpResult = await axios.post(
        this.serverUrl + "yasale/otp/send",
        body,
        {
          headers: {
            AUTHORIZATION: "Bearer xxx xxx",
          },
        }
      );

      if (otpResult.data && otpResult.data.responsecode == 200) {
        // Assign ref data to store
        this.$store.state.ref = otpResult.data.data;
      } else {
        await this.$swal.fire({
          type: "error",
          text: "มีบางอย่างผิดพลาด",
        });
      }

      this.showCountdowntimer = true;
      this.loading = false;
    },
    async SubmitProcess() {
      let IsValid = await this.$refs.observer.validate();
      if (!IsValid) {
        return;
      }

      this.loading = true;
      // Check OTP is valid
      let validOTP = await this.CheckOTP();
      if (!validOTP) {
        return;
      }
      this.loading = false;

      // If success emit to parent to fill account detail
      this.$emit("nextstep");
    },
    async CheckOTP() {
      let params = {
        pageId: this.pageId,
        userId: this.userid,
        otp: this.otp,
        ref: this.ref.refCode,
      };
      let otpResult = await axios.get(this.serverUrl + "yasale/otp/validate", {
        params: params,
        headers: {
          AUTHORIZATION: "Bearer xxx xxx",
        },
      });
      if (
        otpResult.data &&
        otpResult.data.responsecode == 200 &&
        otpResult.data.status
      ) {
        return true;
      } else {
        this.$swal.fire({
          type: "error",
          text: "otp ไม่ถูกต้องหรือหมดอายุแล้ว",
        });
        return false;
      }
    },
  },
};
</script>
